import React from "react";

const RepeatIcon = ({ fill, onclick }) => {
  return (
    <svg
      onClick={onclick}
      className=" cursor-pointer shrink-0 order-0"
      id="media-repeat-all"
      xmlns="http://www.w3.org/2000/svg"
      width="24.019"
      height="22.753"
      viewBox="0 0 24.019 22.753"
    >
      <path
        id="Path_3"
        d="M19.064,2V5.792H7.688A5.688,5.688,0,0,0,2,11.48v1.9H3.9v-1.9A3.792,3.792,0,0,1,7.688,7.688H19.064V11.48l6.321-4.74Z"
        transform="translate(-1.367 -2)"
        fill={fill}
      />
      <path
        id="Path_4"
        d="M7.987,19.376V15.584H19.364A5.688,5.688,0,0,0,25.052,9.9V8h-1.9V9.9a3.792,3.792,0,0,1-3.792,3.792H7.987V9.9l-6.321,4.74Z"
        transform="translate(-1.666 3.376)"
        fill="#232629"
      />
    </svg>
  );
};

export default RepeatIcon;
